import type { PagedResultDto } from "../dto/pagedResultDto"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { FeedbackModel } from "@models/communication/Feedback/FeedbackModel"
import { downloadFile } from "@lib/helperFile"
import dayjs from "dayjs"

class FeedbackService {
  public async create(body: any) {
    const res = await http.post("api/services/app/Feedback/Create", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async update(body: any) {
    const res = await http.put("api/services/app/Feedback/Update", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async delete(id: number) {
    const result = await http.delete("api/Feedback/Delete", {
      params: { id },
    })
    return result.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("Error"), L("EntityNotFound"))
    }

    const result = await http.get("api/services/app/Feedback/Get", {
      params: { id },
    })

    return FeedbackModel.assign(result.data.result)
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Feedback/GetAll", {
      params,
    })
    const { result } = res.data
    return result
  }
  public async getGetAllCustomerComboBox(params: any): Promise<any> {
    const res = await http.get("api/services/app/Feedback/GetAllCustomerComboBox", {
      params,
    })
    return res.data.result
  }

  public async getInternalMessage(params: any): Promise<any> {
    const res = await http.get("api/services/app/ChatMessage/GetAll", {
      params,
    })
    return res.data.result
  }

  public async createInternalMessage(body: any): Promise<any> {
    const res = await http.post("api/services/app/ChatMessage/Create", body)
    return res.data.result
  }

  public async getDashboardStatus(params: any): Promise<any> {
    const res = await http.get("api/services/app/Feedback/GetDashboardStatus", {  
      params
    })
    return res.data.result
  }

  public async exportFeedback(params: any): Promise<any> {
    const res = await http.get("api/Export/ExportFeedback", {
      params,
      responseType: "blob",
    })
    downloadFile(res.data, `EXPORT-FEEDBACK-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
    return res.data
  }

  public async activeFeedback(params: any): Promise<any> {
    const res = await http.post("api/services/app/Feedback/Active", null, { params })
    return res.data.result
  }

  public async getAuditLog(id: number): Promise<any> {
    const res = await http.get("api/services/app/Feedback/GetAuditLogs", {
      params: { id },
    })
    return res.data.result
  }
}

export default new FeedbackService()
